import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { Breakpoint, useScreenBreakPoints } from '~/utils'
import HomRightArrowIcon from '~/components/Icons/svgs/HomRightArrowIcon'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import { useRedirectToCustomerPortal } from '~/settings-scenario/hooks/useRedirectToCustomerPortal'

const mediaQuery = [{ screen: '(min-width: 280px)', width: '20px' }]

export function StripeCustomerPortal(): React.ReactElement {
  const { t } = useTranslation('settings')

  const isSmallScreen = useScreenBreakPoints({ lt: Breakpoint.XL })

  const isActiveClass = isSmallScreen ? 'text-black-link' : 'text-black-link'
  const hoverClass = isSmallScreen ? 'text-black-link' : 'text-purple'
  const onClick = useRedirectToCustomerPortal()

  return (
    <div className="cursor-pointer flex" onClick={() => onClick()}>
      <div className="mt-1 flex">
        <li className={`text-sm md:text-md hover:${hoverClass} ${isActiveClass}`}>{t('managePayment')}</li>
        {isSmallScreen && (
          <ResponsiveImage
            alt={t('subscriptionRedirect')}
            height={20}
            imageClassName="ml-1"
            imageWidths="20"
            mediaQuery={mediaQuery}
            srcKey="subscription/subscription-redirect-icon.png"
            width={20}
          />
        )}
      </div>

      {isSmallScreen && (
        <div className="font-normal flex ml-auto">
          <SVGIcon icon={HomRightArrowIcon} pathClassName="text-black" />
        </div>
      )}
    </div>
  )
}
